var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"package-container",attrs:{"fluid":""}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"auto"}},[_c('ChoosePlan',{attrs:{"package":_vm.Category,"is-before-sign-up":true,"width":"100%"},on:{"returnValue":_vm.call}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }